import type { Matrix, Point } from "@msuite/utils/types";
import type { GestureResponderEvent } from "react-native";

export function getPointDistance(a: Point, b: Point): number {
	return Math.hypot(a.x - b.x, a.y - b.y);
}

export type GetWebSvgPointFn = typeof getWebSvgPoint;

export function getWebSvgPoint(
	svg: SVGSVGElement,
	e: React.MouseEvent | MouseEvent | React.TouchEvent | TouchEvent | GestureResponderEvent,
): Point {
	// @ts-expect-error
	const pt = svg.createSVGPoint(e);
	const src = "touches" in e && e.touches.length > 0 ? e.touches[0] : (e as MouseEvent);
	pt.x = (src as { clientX: number }).clientX;
	pt.y = (src as { clientY: number }).clientY;
	// @ts-expect-error
	const matrix = svg.getScreenCTM(e);
	if (!matrix) return { x: 0, y: 0 };
	const inv = matrix.inverse();
	const transformed = pt.matrixTransform(inv);
	return { x: transformed.x, y: transformed.y };
}

export type GetRnSvgPointFn = typeof getRnSvgPoint;

export function getRnSvgPoint(screenX: number, screenY: number, matrix: Matrix | null): Point {
	if (!matrix) return { x: 0, y: 0 };
	const det = matrix.a * matrix.d - matrix.b * matrix.c;
	if (det === 0) return { x: 0, y: 0 };
	const invA = matrix.d / det;
	const invB = -matrix.b / det;
	const invC = -matrix.c / det;
	const invD = matrix.a / det;
	const invE = (matrix.c * matrix.f - matrix.d * matrix.e) / det;
	const invF = (matrix.b * matrix.e - matrix.a * matrix.f) / det;
	return {
		x: invA * screenX + invC * screenY + invE,
		y: invB * screenX + invD * screenY + invF,
	};
}
